import lighthouse from "../../../../img/web/knowus/values/lighthouse.jpg";
import { RefreshCw, Heart, Brain, Sparkles, ArrowLeftRight, ShieldCheck, Network } from "lucide-react";
import { useTranslation } from "../../../../i18n/useTranslation";

const ICONS = [RefreshCw, Heart, Brain, Sparkles, ArrowLeftRight, ShieldCheck, Network];

const Values = () => {
  const { t } = useTranslation();
  const items = t("values.items");

  return (
    <div id="values" className="band-a scroll-mt-24">
      <img className="w-full block" src={lighthouse} alt="" />
      <h1 className="text-center">{t("values.headingLine1")}<br />{t("values.headingLine2")}</h1>
      <div className="max-w-xl mx-auto text-center pt-2 px-5">
        <p className="mini">{t("values.intro")}</p>
      </div>

      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-5 py-10">
        {items.map((it, i) => {
          const Icon = ICONS[i];
          return (
            <div key={i} className="card-ledger text-center">
              <Icon className="mx-auto" size={40} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
              <div className="pt-2">
                <h4>{it.title}</h4>
                <p className="mini">{it.body}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Values;
